import React from 'react';

const UserProfile = props => {
	return(
		<>
			<h2>Личный профиль</h2>
		</>
	);
}

export default UserProfile;